import {useEffect, useState} from 'react';

/**
 * Защелка «разблокировано»: становится true, как только blocked впервые стал
 * false, и назад уже не возвращается.
 *
 * Нужна там, где остановить начатое дороже, чем задержать старт. Пример —
 * витрина главного меню: пока над меню висят модалки, запись не начинают, но
 * модалка, открытая позже (магазин, правила), не должна ее гасить —
 * размонтирование ReplayRunner отмотало бы запись к началу.
 */
export function useUnblockedOnce(isBlocked) {
  const [isUnblocked, setIsUnblocked] = useState(!isBlocked);

  useEffect(() => {
    if (!isBlocked) {
      setIsUnblocked(true);
    }
  }, [isBlocked]);

  return isUnblocked;
}
